"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DettaglioInfoDashboardDtoToJSON = exports.DettaglioInfoDashboardDtoFromJSONTyped = exports.DettaglioInfoDashboardDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function DettaglioInfoDashboardDtoFromJSON(json) {
    return DettaglioInfoDashboardDtoFromJSONTyped(json, false);
}
exports.DettaglioInfoDashboardDtoFromJSON = DettaglioInfoDashboardDtoFromJSON;
function DettaglioInfoDashboardDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'processiInseriti': !runtime_1.exists(json, 'processiInseriti') ? undefined : _1.DettaglioInfoProcessoDashboardDtoFromJSON(json['processiInseriti']),
        'processiInseritiNonAvviati': !runtime_1.exists(json, 'processiInseritiNonAvviati') ? undefined : _1.DettaglioInfoProcessoDashboardDtoFromJSON(json['processiInseritiNonAvviati']),
        'processiAvviati': !runtime_1.exists(json, 'processiAvviati') ? undefined : _1.DettaglioInfoProcessoDashboardDtoFromJSON(json['processiAvviati']),
        'processiConclusi': !runtime_1.exists(json, 'processiConclusi') ? undefined : _1.DettaglioInfoProcessoDashboardDtoFromJSON(json['processiConclusi']),
        'processiScaduti': !runtime_1.exists(json, 'processiScaduti') ? undefined : _1.DettaglioInfoProcessoDashboardDtoFromJSON(json['processiScaduti']),
        'processiPreviewInviata': !runtime_1.exists(json, 'processiPreviewInviata') ? undefined : _1.DettaglioInfoProcessoDashboardDtoFromJSON(json['processiPreviewInviata']),
        'percConversionRate': !runtime_1.exists(json, 'percConversionRate') ? undefined : json['percConversionRate'],
        'mediaTemporaleDiAttesa': !runtime_1.exists(json, 'mediaTemporaleDiAttesa') ? undefined : json['mediaTemporaleDiAttesa'],
    };
}
exports.DettaglioInfoDashboardDtoFromJSONTyped = DettaglioInfoDashboardDtoFromJSONTyped;
function DettaglioInfoDashboardDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'processiInseriti': _1.DettaglioInfoProcessoDashboardDtoToJSON(value.processiInseriti),
        'processiInseritiNonAvviati': _1.DettaglioInfoProcessoDashboardDtoToJSON(value.processiInseritiNonAvviati),
        'processiAvviati': _1.DettaglioInfoProcessoDashboardDtoToJSON(value.processiAvviati),
        'processiConclusi': _1.DettaglioInfoProcessoDashboardDtoToJSON(value.processiConclusi),
        'processiScaduti': _1.DettaglioInfoProcessoDashboardDtoToJSON(value.processiScaduti),
        'processiPreviewInviata': _1.DettaglioInfoProcessoDashboardDtoToJSON(value.processiPreviewInviata),
        'percConversionRate': value.percConversionRate,
        'mediaTemporaleDiAttesa': value.mediaTemporaleDiAttesa,
    };
}
exports.DettaglioInfoDashboardDtoToJSON = DettaglioInfoDashboardDtoToJSON;
